import * as yup from 'yup';

export const SendOfMexalConf = {
  schema: yup.object({
    note: yup.string().nullable(),
  }),
  defaultValues: {
    note: '',
  },
  fields: [
    {
      id: 'send_of_mexal_divider',
      type: 'divider',
      label: 'Send OF to Mexal',
      xs: 12,
    },
    {
      id: 'note',
      name: 'note',
      type: 'text',
      label: 'Note',
      xs: 12,
    },
  ],
};